import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { router } from "../router/index";
import {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
} from "../js/oauth";
import { setSnackBarInfo } from "../js/common_function";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

const state = {
  status: "",
  token: "",
  info: "",
  memberType: localStorage.getItem("memberType"),
  tokenKey: localStorage.getItem("token-key"),
  warningMsg: "아직 회원이 아니신가요?",
  newTokenCheck: false,
  // financeBoard: false,
  // Comment: false,
  // English: false,
  // Exercise: false,
  // Humor: false,
  // IT: false,
  // realEstateBoard: false,
  // Travel: false,
  // privateBulletinBoard: false,
  // bulletinBoard: false,
};

const getters = {
  isAuthenticated(state) {
    return !!state.tokenKey;
  },
  memberType(state) {
    return state.memberType;
  },
  status(state) {
    return state.status;
  },
  token(state) {
    return state.token;
  },
  info(state) {
    return state.info;
  },
};

const mutations = {
  SET_INFO(state, detailInfo) {
    state.status = detailInfo.status;
    state.token = detailInfo.token;
    state.info = detailInfo.info;
  },
  // SET_NEW(state, data) {
  //   state.financeBoard           = data.financeBoard;
  //   state.Comment           = data.Comment;
  //   state.English            = data.English;
  //   state.Exercise           = data.Exercise;
  //   state.Humor              = data.Humor;
  //   state.IT     = data.IT;
  //   state.realEstateBoard= data.realEstateBoard;
  //   state.Travel               = data.Travel;
  //   state.privateBulletinBoard   = data.privateBulletinBoard;
  //   state.bulletinBoard   = data.bulletinBoard;
  // },
  LOGIN(state) {
    state.tokenKey = localStorage.getItem("token-key");
    state.memberType = localStorage.getItem("memberType");
    state.warningMsg = "로그인 성공";
    this.commit("SET_SNACKBAR", setSnackBarInfo("로그인 완료"));
  },
  LOGOUT(state) {
    state.tokenKey = "";
    state.memberType = "";
    this.commit("SET_SNACKBAR", setSnackBarInfo("로그아웃 완료"));

    state.warningMsg = "아직 회원이 아니신가요?";
  },
  INIT(state) {
    state.tokenKey = "";
    state.memberType = "";
  },
  LOGIN_FAIL(state) {
    state.warningMsg = "아이디와 비밀번호를 확인해주세요.";
    this.commit(
      "SET_SNACKBAR",
      setSnackBarInfo("아이디 혹은 비밀번호를 확인해주세요.")
    );

    // this.commit('OPEN_MODAL', {
    //   title: '로그인 실패',
    //   content: '아이디 혹은 비밀번호를 확인해주세요.',
    //   option1: '닫기',
    // });
  },
  LOGIN_EXCESS_LOCK(state) {
    state.warningMsg = "계정이 잠겼습니다. 관리자에게 문의하세요.";
    this.commit(
      "SET_SNACKBAR",
      setSnackBarInfo("5회 이상 패스워드가 틀려서 계정이 잠겼습니다.")
    );
  },
  LOGIN_LOCK(state) {
    state.warningMsg = "계정이 잠겼습니다. 관리자에게 문의하세요.";
    this.commit("SET_SNACKBAR", setSnackBarInfo("계정이 차단되었습니다."));
  },
  LOGIN_LOCK_FIRST(state) {
    state.warningMsg = "계정이 잠겼습니다. 관리자에게 문의하세요.";
    this.commit(
      "SET_SNACKBAR",
      setSnackBarInfo("최초 로그인 시 관리자 승인이 필요합니다.")
    );
  },
  JOIN_FAIL(state) {
    state.warningMsg = "회원가입 정보를 확인해주세요.";
  },
};

function getInfoFunc(path) {
  return AXIOS({
    url: "/info",
    method: "post",
    data: {
      path: path,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function matchInfoFunc() {
  AXIOS({
    url: "/match",
    method: "post",
    headers: {
      "token-setup": localStorage.getItem("token-setup"),
    },
  }).then((response) => {
    if (response.data.statusCode == 200) {
      localStorage.setItem("token-key", response.headers["new-token-key"]);
    } else {
      clearLocalStorage();
    }
  });
}

function getInfo(token) {
  return AXIOS({
    url: "/info",
    method: "post",
    headers: {
      "token-key": token,
    },
  });
}

function matchRefreshToken(token) {
  // console.log("매치 펑션 진입");
  return AXIOS({
    url: "/match",
    method: "post",
    headers: {
      "token-setup": token,
    },
  });
}

function loginRequest(member) {
  return AXIOS({
    url: "/signin",
    method: "post",
    data: {
      username: member.username,
      password: member.password,
    },
  });
}

function matchLogin(member) {
  // console.log("매치 로그인 펑션 진입");

  return AXIOS({
    url: "/matchLogin",
    method: "post",
    data: {
      username: member.username,
      password: member.password,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function joinRequest(member) {
  return AXIOS({
    url: "/signup",
    method: "post",
    data: {
      username: member.username,
      password: member.password,
      nickname: member.nickname,
    },
  });
}
function emailcheck(email) {
  return AXIOS({
    url: "/emailcheck",
    method: "post",
    data: {
      username: email,
    },
  });
}
function verifycheck(code) {
  return AXIOS({
    url: "/verifyCode",
    method: "post",
    data: {
      verifycode: code,
    },
  });
}

const actions = {
  async REQUEST_GET_INFO(context, token) {
    try {
      const response = await getInfo(token);
      if (response.data.statusCode === 200) {
        setLocalStorageExpiredStatus(response.data);

        context.commit("SET_INFO", {
          status: "정보 조회 성공",
          token: JSON.stringify(response.data.statusCode),
          info: JSON.stringify(response.data.data),
        });
        return response;
      } else {
        setLocalStorageExpiredStatus(response.data);
        context.commit("SET_INFO", {
          status: "정보 조회 실패1",
          token: JSON.stringify(response.data.statusCode),
          info: JSON.stringify(response.data.data),
        });
        return response;
      }
    } catch (e) {
      console.log(e);
      context.commit("SET_INFO", {
        status: "정보 조회 실패2",
        token: "",
        info: e.message,
      });
    }
  },
  async MATCH_INFO(context, token) {
    try {
      const res = await matchRefreshToken(token);
      if (res.data.statusCode === 200) {
        // console.log(res.data)
        setLocalStorageNewTokenKey(res.data, res.headers);
        // localStorage.setItem("token-key", response.headers["new-token-key"]);
        context.commit("SET_INFO", {
          status: "새 토큰 발행 성공",
          token: JSON.stringify(res.data),
          info: JSON.stringify(res.data.statusCode),
        });
        return res;
      } else {
        context.commit("SET_INFO", {
          status: "tokensetup만료됨",
          token: JSON.stringify(res.data),
          info: JSON.stringify(res.data.statusCode),
        });
        return res;
      }
    } catch (e) {
      console.log(e);
      context.commit("SET_INFO", {
        status: "매칭 실패",
        token: "",
        info: e.message,
      });
    }
  },

  async REQUEST_LOGIN(context, member) {
    try {
      context.commit("START_SPINNER");

      const res = await loginRequest(member);
      if (res.data.statusCode === 200) {
        // console.log(res.data.data)
        // context.commit('SET_NEW', res.data.data);
        setLocalStorage(res.data, res.headers);
        context.commit("SET_INFO", {
          status: "로그인 성공",
          token: "",
          info: "",
        });
        context.commit("LOGIN");
        router.push("/");
      } else {
        context.commit("SET_INFO", {
          status: "로그인 실패",
          token: "",
          info: "",
        });
        if (res.data.accountExcessLock === true) {
          context.commit("LOGIN_EXCESS_LOCK");
        } else if (res.data.accountLock === true) {
          context.commit("LOGIN_LOCK");
        } else if (res.data.accountLockFirst === true) {
          context.commit("LOGIN_LOCK_FIRST");
        } else {
          context.commit("LOGIN_FAIL");
        }
      }
    } catch (e) {
      console.log(e);
      context.commit("SET_INFO", {
        status: "실패",
        token: "",
        info: JSON.stringify(e.message),
      });
    }
  },
  async MATCH_LOGIN(context, member) {
    try {
      const res = await matchLogin(member);
      return res;
    } catch (e) {
      console.log(e);
    }
  },
  async REQUEST_JOIN(context, member) {
    try {
      const res = await joinRequest(member);
      if (res.data.statusCode === 200) {
        context.commit("SET_INFO", {
          status: "회원가입 성공",
          token: "",
          info: "",
        });
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo(
            "회원가입 완료되었습니다. 관리자 승인 후 사용 가능합니다."
          )
        );
        router.push("/");
      } else {
        context.commit("SET_INFO", {
          status: "회원가입 실패",
          token: "",
          info: "",
        });
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("회원가입에 실패하였습니다.")
        );
      }
    } catch (e) {
      console.log(e);
      context.commit("SET_INFO", {
        status: "실패",
        token: "",
        info: JSON.stringify(e.message),
      });
    }
  },
  async EMAIL_CHECK(context, email) {
    try {
      const res = await emailcheck(email);
      if (res.data.statusCode === 200) {
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo(email + "로 이메일 인증 메일을 보냈습니다.", 5000)
        );
        return true;
      } else {
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("이메일 인증에 실패하였습니다.")
        );
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  },
  async VERIFY_CHECK(context, code) {
    try {
      const res = await verifycheck(code);
      if (res.data.statusCode === 200) {
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("인증이 정상적으로 완료되었습니다.")
        );
        return true;
      } else {
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("인증에 실패하였습니다.")
        );
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  },

  async LOG_OUT(context) {
    try {
      clearLocalStorage();
      context.commit("LOGOUT");
      router.push("/login");
    } catch (e) {}
  },

  async GET_INFO(context, path) {
    try {
      const res = await getInfoFunc(path);
      return res;
    } catch (e) {
      console.log("access token 만료", e);
    }
  },
  async MATCH_INFO(context) {
    try {
      matchInfoFunc();
    } catch (e) {
      console.log("refresh token 만료", e);
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
